<template>
  <button v-if="!embed" class="payButton checkout_btn btn btn-success" @click="payWithPaystack">
    <slot>Make Payment</slot>
  </button>
  <div v-else id="paystackEmbedContainer" />
</template>

<script type="text/javascript">
export default {
  props: {
    embed: {
      type: Boolean,
      default: false
    },
    paystackkey: {
      type: String,
      required: true
    },
    reference: {
      type: String,
      required: true
    },
    channels: {
      type: Array,
      default: function() {
        return ["card", "bank"];
      }
    },
    accessCode: {
      type: String,
      default: ""
    },
    callback: {
      type: Function,
      required: true,
      default: function(response) {
        console.log(response);
      }
    },
    close: {
      type: Function,
      required: true,
      default: function() {}
    },
    metadata: {
      type: Object,
      default: function() {
        return {};
      }
    },
    currency: {
      type: String,
      default: "NGN"
    },
    plan: {
      type: String,
      default: ""
    },
    quantity: {
      type: String,
      default: ""
    },
    subaccount: {
      type: String,
      default: ""
    },
    transactionCharge: {
      type: Number,
      default: 0
    },
    bearer: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      scriptLoaded: null,
      firstname: this.$store.state.firstname,
      lastname: this.$store.state.lastname,
      email: this.$store.state.email,
      amount: this.$store.state.amount
    };
  },
  created() {
    this.scriptLoaded = new Promise(resolve => {
      this.loadScript(() => {
        resolve();
      });
    });
  },
  mounted() {
    if (this.embed) {
      this.payWithPaystack();
    }
  },
  methods: {
    loadScript(callback) {
      const script = document.createElement("script");
      script.src = "https://js.paystack.co/v1/inline.js";
      document.getElementsByTagName("head")[0].appendChild(script);
      if (script.readyState) {
        // IE
        script.onreadystatechange = () => {
          if (
            script.readyState === "loaded" ||
            script.readyState === "complete"
          ) {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        // Others
        script.onload = () => {
          callback();
        };
      }
    },

    payWithPaystack() {
      this.scriptLoaded &&
        this.scriptLoaded
          .then(() => {
            const paystackOptions = {
              key: this.paystackkey,
              email: this.email,
              firstname: this.firstname,
              lastname: this.lastname,
              channels: this.channels,
              amount: this.amount,
              access_code: this.accessCode,
              ref: this.reference,
              callback: response => {
                this.callback(response);
                this.$store.dispatch("clearCart");
                this.$router.push("/");
              },
              onClose: () => {
                this.close();
                this.$store.dispatch("clearCart");
                this.$router.push("/");
              },
              metadata: this.metadata,
              currency: this.currency,
              plan: this.plan,
              quantity: this.quantity,
              subaccount: this.subaccount,
              transaction_charge: this.transaction_charge,
              bearer: this.bearer
            };

            if (this.embed) {
              paystackOptions.container = "paystackEmbedContainer";
            }

            const handler = window.PaystackPop.setup(paystackOptions);
            if (!this.embed) {
              handler.openIframe();
            }
          })
          .catch(err => {
            console.log("network Error!!:" + err);
          });
    }
  }
};
</script>
